import { createRouter, createWebHistory } from 'vue-router'
import { STATIC_ROUTES } from '@/routers/routes-static'
import { useUserStore } from '@/stores/user'

const router = createRouter({
  history: createWebHistory(),
  routes: STATIC_ROUTES,
  scrollBehavior: () => ({ top: 0 }),
})

router.beforeEach((to, _from, next) => {
  const user = useUserStore()
  user.hydrateFromStorage()

  const publicRoutes = ['/login']
  if (publicRoutes.some((path) => to.path.startsWith(path))) return next()

  if (!user.isLogged) return next({ path: '/login', replace: true, query: { redirect: to.fullPath } })

  next()
})

export default router
